import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { formatDateSafe } from "@/utils/dateHelpers";

/**
 * Shared sub-block that renders a "what happened?" textarea + a
 * "Replacement Segment" dropdown. Used by both AddSegmentDialog (mistake-only)
 * and EditSegmentDialog (mistake AND cancellation share an instance with a
 * different colour wrapper). The wrapper styling stays at the call site so
 * each context can pick its own background/border.
 */
export function MistakeNotesAndReplacement({
  notesValue,
  onNotesChange,
  notesLabel = "What happened?",
  notesId = "mistake-notes",
  notesPlaceholder = "Example: Flight was cancelled, had to book new one. Lost $450...",
  replacementValue,
  onReplacementChange,
  replacementId = "replacement-segment",
  allSegments = [],
}) {
  return (
    <>
      <div>
        <Label htmlFor={notesId} className="text-sm">
          {notesLabel} <span className="text-red-500">*</span>
        </Label>
        <Textarea
          id={notesId}
          placeholder={notesPlaceholder}
          value={notesValue || ""}
          onChange={(e) => onNotesChange(e.target.value)}
          rows={2}
          maxLength={1000}
          className="mt-1"
        />
        <p className="text-xs text-gray-500 mt-1">{(notesValue || "").length}/1000 characters</p>
      </div>

      <div>
        <Label htmlFor={replacementId} className="text-sm">
          Replacement Segment (Optional)
        </Label>
        <Select
          value={replacementValue || ""}
          onValueChange={(value) => onReplacementChange(value === "none" ? "" : value)}
        >
          <SelectTrigger className="mt-1">
            <SelectValue placeholder="Select replacement segment" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="none">No replacement</SelectItem>
            {allSegments.map((seg) => {
              const dateStr = seg.start_date || seg.start_datetime;
              const date = dateStr ? formatDateSafe(dateStr) : "No date";
              let label = "";
              if (seg.type === "flight" || seg.type === "train" || seg.type === "bus") {
                label = `${seg.type.charAt(0).toUpperCase() + seg.type.slice(1)}: ${seg.from_location} → ${seg.to_location} (${date})`;
              } else if (seg.type === "accommodation") {
                label = `Accommodation: ${seg.property_name || seg.accommodation_location || seg.vendor_name} (${date})`;
              } else {
                label = `${seg.type.charAt(0).toUpperCase() + seg.type.slice(1)}: ${seg.vendor_name} (${date})`;
              }
              return (
                <SelectItem key={seg.id} value={seg.id}>
                  {label}
                </SelectItem>
              );
            })}
          </SelectContent>
        </Select>
      </div>
    </>
  );
}

export default MistakeNotesAndReplacement;
